(function () {
	const tagLinks = document.querySelectorAll(
		".references-filter a, .reference .tags a",
	);
	const filterLinks = document.querySelectorAll(".references-filter a");
	const references = document.querySelectorAll(".reference");
	const activeFilterLink = (id) => {
		filterLinks.forEach((f) => {
			if (f.dataset.tagid == id) {
				f.classList.add("selected");
			} else {
				f.classList.remove("selected");
			}
		});
	};
	const showRefs = (refs) => {
		console.log("filtering", refs);
		references.forEach((ref) => {
			console.log("filter ?", ref);
			if (!refs.includes(ref)) ref.classList.add("hide");
			else ref.classList.remove("hide");
		});
	};
	const showAllRefs = () => {
		references.forEach((ref) => {
			ref.classList.remove("hide");
		});
	};
	let refsByTag = [];
	references.forEach((ref) => {
		let tags = ref.dataset.tags.split(",");
		console.log(ref, tags);
		tags.forEach((tag) => {
			if (refsByTag[tag]) {
				refsByTag[tag].push(ref);
			} else {
				refsByTag[tag] = [ref];
			}
		});
	});
	tagLinks.forEach((l) => {
		l.addEventListener("click", (e) => {
			e.preventDefault();
			id = l.dataset.tagid;
			console.log(id);
			if (id == "all") {
				console.log("show all");
				showAllRefs();
			} else {
				console.log("searching id", id, refsByTag[id]);
				showRefs(refsByTag[id]);
			}
			activeFilterLink(id);
		});
	});
})();
